import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookies_accepted");
    if (!accepted) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem("cookies_accepted", "1");
    setVisible(false);
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50"
        >
          <div className="card p-5 shadow-2xl shadow-black/50 border-navy-600">
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gold-400/60 to-transparent rounded-t-2xl" />
            <p className="text-sm text-slate-300 mb-4 leading-relaxed">
              Ta aplikacja używa lokalnych plików cookie wyłącznie do przechowywania sesji logowania. Nie przetwarzamy danych osobowych ani nie udostępniamy ich osobom trzecim.
            </p>
            <div className="flex items-center gap-3">
              <button onClick={accept} className="btn-primary text-sm py-2 px-5">
                Rozumiem
              </button>
              <span className="text-xs text-slate-600">Aplikacja wewnętrzna klasy</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
